import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { ICustomService } from "@common/SelectYourNumber/interface/ISubscription";
import { TITLE_INHERIT_STYLE, WORDPRESS_URL } from "@constants";
import { useTerminateNumber } from "@features/TerminateNumber/hook/useTerminateNumber";
import {
    Card,
    CardContent,
    CardHeader,
    Grid,
    Typography,
    Button,
    FormControlLabel,
    Checkbox,
    Link,
} from "@material-ui/core";
import { getLanguage } from "@utils/changeLanguage";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IFetchState } from "src/itsf/fetch/fetcherUtils";

interface IParams {
    service: ICustomService;
    postTerminationNumberStatus: IFetchState;
    postNumberTermination: () => void;
}

const ScheduleTermination = (props: IParams) => {
    const { service, postTerminationNumberStatus, postNumberTermination } = props;
    const { t } = useTranslation("accountDetails");
    const [termsChecked, setTermsChecked] = useState<boolean>(false);

    const handleTerminationClick = () => {
        postNumberTermination();
    };

    const termsAndConditionsSentence = (
        <Link
            color="secondary"
            href={`${WORDPRESS_URL}/${getLanguage()}/terms/#a6870cb83e8551872`}
            rel="noopener"
            target="_blank"
            underline="always"
        >
            <b> {t("termsAndConditions")}</b>
        </Link>
    );

    return (
        <Grid item xs={12}>
            <Card elevation={2}>
                <CardHeader
                    className="card-header card-header__right"
                    title={t("terminateMyNumber")}
                    titleTypographyProps={TITLE_INHERIT_STYLE}
                />
                <CardContent>
                    <div className="card-header__circle" />
                    <HandleErrorAndLoading
                        error={postTerminationNumberStatus.error}
                        isLoading={postTerminationNumberStatus.isLoading}
                    >
                        {/* <Grid container justify={"center"}>
                        <Grid item xs={12} md={9}>
                            <Typography color="secondary" variant="body2">
                                {t("scheduleHere")}
                            </Typography>
                            <Typography color="secondary" variant="body2">
                                {t("deactivationAction", { number: service.name })}
                            </Typography>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={termsChecked}
                                        name={"termsAndConditions"}
                                        onChange={(event) => setTermsChecked(event.target.checked)}
                                    />
                                }
                                label={"termsAndConditionsSentence"}
                            />
                        </Grid>
                    </Grid> */}
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Typography color="secondary" variant="body2">
                                {t("scheduleHere")}
                            </Typography>
                            <Typography color="secondary" variant="body2">
                                {t("deactivationAction", { number: service.name })}
                            </Typography>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={termsChecked}
                                        name={"termsAndConditions"}
                                        onChange={(event) => setTermsChecked(event.target.checked)}
                                    />
                                }
                                label={termsAndConditionsSentence}
                            />
                            {postTerminationNumberStatus.error && (
                                <Typography color="error" variant="body1">
                                    {postTerminationNumberStatus.error.errorMessage}
                                </Typography>
                            )}
                        </Grid>
                        <Grid container justify="center" style={{ marginTop: "15px" }}>
                            <Grid item>
                                <Button
                                    disabled={!termsChecked}
                                    color="secondary"
                                    type="button"
                                    variant="outlined"
                                    onClick={handleTerminationClick}
                                >
                                    {t("scheduleNow")}
                                </Button>
                            </Grid>
                        </Grid>
                    </HandleErrorAndLoading>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default ScheduleTermination;
